import React from 'react';
import { formatInTimeZone } from 'date-fns-tz';
import { ReactComponent as NoImageIcon } from '../../images/no-image.svg';
import './AcceptedUnprocessedIssuesModal.css';

export default function AcceptedUnprocessedIssuesModal({
  acceptedUnprocessedIssue,
  increaseFormStep,
  setFormInfo,
}) {
  const setIssueDetails = (issueDetails) => {
    setFormInfo((prevValue) => {
      return {
        ...prevValue,
        issueDetails,
      };
    });

    increaseFormStep();
  };

  const geoUrl = process.env.REACT_APP_GEOSERVER;

  return (
    <div
      className="accepted-unprocessed-report-container"
      key={acceptedUnprocessedIssue.code}
      onClick={() => setIssueDetails(acceptedUnprocessedIssue)}
    >
      {acceptedUnprocessedIssue.image ? (
        <img
          className="accepted-unprocessed-report-thumbnail"
          src={`${geoUrl}/static/issues/${acceptedUnprocessedIssue.image}`}
          alt=""
        />
      ) : (
        <div className="accepted-unprocessed-report-no-image">
          <NoImageIcon style={{ height: '2em' }} />
        </div>
      )}

      <div className="accepted-unprocessed-report-details">
        <div className="accepted-unprocessed-report-header">
          {acceptedUnprocessedIssue.address ? (
            <h2 className="accepted-unprocessed-report-address">
              {acceptedUnprocessedIssue.address}
            </h2>
          ) : (
            <div
              className="accepted-unprocessed-report-address"
              style={{ color: '#9C9C9C', fontWeight: 400 }}
            >
              Bez adrese
            </div>
          )}

          <div className="accepted-unprocessed-report-date">
            {formatInTimeZone(new Date(), 'Europe/Paris', 'dd.MM.yyyy.') !==
            formatInTimeZone(
              acceptedUnprocessedIssue.reportedAt,
              'Europe/Paris',
              'dd.MM.yyyy.'
            )
              ? formatInTimeZone(
                  acceptedUnprocessedIssue.reportedAt,
                  'Europe/Paris',
                  'dd.MM.yyyy.'
                )
              : formatInTimeZone(
                  acceptedUnprocessedIssue.reportedAt,
                  'Europe/Paris',
                  'HH:mm'
                )}
          </div>
        </div>

        <p className="accepted-unprocessed-report-description">
          {acceptedUnprocessedIssue.description}
        </p>
      </div>
    </div>
  );
}
